import styled from "styled-components";

import { COLORS } from '@treelab/panda'

export const Container = styled.div`
  margin-top: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const MessageContainer = styled.div`
  margin-left: 8px;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.blue};
`;
